// Libs
import { Session } from "@collectivehealth/cog";

// Constants
import { ROLES } from "constants/authorization";

/**
 * Normal posing check doesn't work for us because we pose
 * as a chAdmin so there is no posing user really. But we can
 * use the actual role as our source of truth because a normal
 * user doesn't come in as a chAdmin, they are a sponsorAdmin
 *
 * @returns {boolean}
 */
export function isPosing() {
  const session = Session.getSession() || {};
  return session.role === ROLES.CH_ADMIN;
}
